import {
  useGreenhouseQuery,
  WorkType,
} from "@faire/retailer-shared/greenhouse/departmentsRequest";
import { IDepartment } from "@faire/retailer-shared/greenhouse/greenhouseApi";
import { StrictLocalizeFunction } from "@faire/web/common/localization";

import { mapDepartmentsWithTieredView } from "./common";

export const useDepartments = (
  strictLocalize: StrictLocalizeFunction
): {
  [WorkType.EMPLOYMENT]: {
    departments: IDepartment[];
    isLoading: boolean;
    isError: boolean;
  };
  [WorkType.CONSULTANT]: {
    departments: IDepartment[];
    isLoading: boolean;
    isError: boolean;
  };
} => {
  const {
    data: employmentData,
    isPending: employmentIsLoading,
    isError: employmentIsError,
  } = useGreenhouseQuery(WorkType.EMPLOYMENT);

  const {
    data: consultantData,
    isPending: consultantIsLoading,
    isError: consultantIsError,
  } = useGreenhouseQuery(WorkType.CONSULTANT);

  let consultantDepartments: IDepartment[] = [];
  let employmentDepartments: IDepartment[] = [];

  if (!employmentIsLoading && !employmentIsError && employmentData) {
    employmentDepartments = mapDepartmentsWithTieredView(
      employmentData,
      strictLocalize
    );
  }

  if (!consultantIsLoading && !consultantIsError && consultantData) {
    consultantDepartments = mapDepartmentsWithTieredView(
      consultantData,
      strictLocalize
    );
  }

  return {
    [WorkType.EMPLOYMENT]: {
      departments: employmentDepartments,
      isLoading: employmentIsLoading,
      isError: employmentIsError,
    },
    [WorkType.CONSULTANT]: {
      departments: consultantDepartments,
      isLoading: consultantIsLoading,
      isError: consultantIsError,
    },
  };
};
